export const TWO_FA_CODE_LENGTH = 6;

export const STRONG_PASSWORD_REGEXP =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d\-#!$@£%^&*()_+|~=`{}[\]:";'<>?,./]{8,}$/;
